"use client";

import { mergeProps, useRender } from "@base-ui/react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { useRef } from "react";

const boxVariants = cva("", {
  variants: {},
  defaultVariants: {},
});

export interface ContainerProps
  extends useRender.ComponentProps<"div">, VariantProps<typeof boxVariants> {}

export const Box = ({ render, className, ...props }: ContainerProps) => {
  const internalRef = useRef<HTMLElement | null>(null);
  const defaultProps: useRender.ElementProps<"div"> = {
    className: cn(boxVariants({ className })),
  };

  const element = useRender({
    defaultTagName: "div",
    render,
    ref: internalRef,
    props: mergeProps<"div">(defaultProps, props),
  });

  return element;
};
